import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import { Switch } from '@/components/ui/switch'
import type { EntityDescriptor, SubjectEntity } from '@/services/api/structuredIngest'
import { canEnableMappingMerge } from './identity'
import { withMappingMerge } from './recipe-edits'

export function MappingMergeToggle<T extends SubjectEntity | EntityDescriptor>({
  item,
  onChange,
}: {
  item: T
  onChange: (next: T) => void
}) {
  const { t } = useTranslation()
  const id = useId()
  const enabled =
    item.merge_enabled !== false && item.identity_rule?.trim().toLowerCase() !== 'source_row'
  const canEnable = canEnableMappingMerge(item)
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={id} className="flex items-center gap-2 text-xs">
        <Switch
          id={id}
          checked={enabled}
          disabled={!enabled && !canEnable}
          onCheckedChange={checked => onChange(withMappingMerge(item, checked))}
        />
        {t('tableMapping.identity.mergeByProperty')}
      </label>
      <p className="text-xs text-muted-foreground">{t('tableMapping.identity.mappingOnly')}</p>
      {!enabled && !canEnable && (
        <p className="text-xs text-muted-foreground">{t('tableMapping.identity.mergeNeedsKey')}</p>
      )}
    </div>
  )
}
